import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getHomeProducts } from "../../api/product"
import { addProducts } from "./productSlice"

const initialState = {
  sections: {
    hero_banner: [],
    new_arrivals: [],
    focus: [],        // ✅ NEW
    social: [],       // ✅ NEW
    all: {
      product_ids: []
    }
  },
  loading: false,
  error: null
}

export const fetchHomeProducts = createAsyncThunk(
  "home/fetchHomeProducts",
  async (_, thunkAPI) => {

    const { dispatch } = thunkAPI

    try {

      const res = await getHomeProducts()
      const data = res.data.data || {}

      const products = data.products || []
      const banners = data.banners || []
      const newArrivals = data.new_arrivals || []
      const focus = data.focus || []        // ✅ NEW
      const social = data.social || []      // ✅ NEW

      // store products globally
      if (products.length) {
        dispatch(addProducts(products))
      }

      return {
        products,
        banners,
        newArrivals,
        focus,     // ✅ NEW
        social     // ✅ NEW
      }

    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data)
    }

  }
)

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    builder

      .addCase(fetchHomeProducts.pending, (state) => {
        state.loading = true
      })

      .addCase(fetchHomeProducts.fulfilled, (state, action) => {

        state.loading = false

        const {
          products = [],
          banners = [],
          newArrivals = [],
          focus = [],     // ✅ NEW
          social = []     // ✅ NEW
        } = action.payload || {}

        // store product ids
        state.sections.all.product_ids = products.map(
          p => p.id || p.public_id
        )

        // assign sections
        state.sections.hero_banner = banners
        state.sections.new_arrivals = newArrivals
        state.sections.focus = focus        // ✅ NEW
        state.sections.social = social      // ✅ NEW

      })

      .addCase(fetchHomeProducts.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload?.message
      })

  }
})

export default homeSlice.reducer